<div id="distributionModal">
  <div class="tw-flex tw-justify-end tw-mr-[5px]">
    <button
      type="button"
      mat-icon-button
      class="close"
      (click)="dismiss()"
      aria-label="Click to close this modal"
    >
      <streamline-icon
        ariaLabel="Click to close this modal"
        name="close"
        width="12"
        height="12"
      ></streamline-icon>
    </button>
  </div>
  <h4 id="dialog-title" class="tw-text-center">Edit Distribution</h4>
  <mat-dialog-content>
    <distribution-list
      [(distribution)]="distribution"
      [(subcompanyDistribution)]="subcompanyDistribution"
      [(distributeToSubcompanies)]="distributeToSubcompanies"
      [enableSubcompanies]="enableSubcompanies"
      [enableFeatureCheck]="enableFeatureCheck"
      (closeEvent)="dismiss()"
    >
    </distribution-list>
  </mat-dialog-content>

  <mat-dialog-actions
    class="tw-flex tw-flex-col md:!tw-justify-end md:!tw-flex-row tw-gap-2.5 tw-pt-4"
  >
    <a
      rv-button
      variant="secondary"
      class="tw-w-full md:!tw-w-40"
      id="distributionAddDisplayButton"
      (click)="dismiss()"
      uiSref="apps.displays.add"
      *requireAccess="'display:fullAccess'"
    >
      Add Display
    </a>
    <div
      class="tw-flex tw-flex-col md:!tw-flex-row tw-gap-2.5 md:!tw-w-fit tw-w-full"
    >
      <button
        rv-button
        variant="secondary"
        id="distributionModalCancelButton"
        type="button"
        (click)="dismiss()"
      >
        Cancel
      </button>
      <button
        rv-button
        id="applyButton"
        type="button"
        class="tw-w-full md:!tw-w-40 !tw-m-0"
        (click)="apply()"
      >
        Apply
      </button>
    </div>
  </mat-dialog-actions>
</div>
